/**
 * @generated SignedSource<<dd8983d982793954c0b246ea37a94a1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type UpdateRoutineUpdateTaskInput = {
  check?: UpdateTaskCheckInput | null;
  number?: UpdateTaskNumberInput | null;
  taskId: string;
  text?: UpdateTaskTextInput | null;
};
export type UpdateTaskCheckInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setSentiments?: ReadonlyArray<TaskSentiment> | null;
  setTitle?: string | null;
};
export type UpdateTaskNumberInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setTitle?: string | null;
  setUnit?: NumberTaskUnit | null;
};
export type UpdateTaskTextInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setTitle?: string | null;
};
export type KPIEditUnitMutation$variables = {
  routineId: string;
  updateTasks: ReadonlyArray<UpdateRoutineUpdateTaskInput>;
};
export type KPIEditUnitMutation$data = {
  readonly routine: {
    readonly update: {
      readonly routine: {
        readonly activeVersion: {
          readonly tasks: ReadonlyArray<{
            readonly id: string;
            readonly unit?: NumberTaskUnit;
          }>;
        };
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type KPIEditUnitMutation = {
  response: KPIEditUnitMutation$data;
  variables: KPIEditUnitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updateTasks"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "updateTasks",
        "variableName": "updateTasks"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "type": "TaskNumber",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIEditUnitMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoutineMutation",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "UpdateRoutinePayload",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineVersion",
                    "kind": "LinkedField",
                    "name": "activeVersion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "tasks",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIEditUnitMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoutineMutation",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "UpdateRoutinePayload",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineVersion",
                    "kind": "LinkedField",
                    "name": "activeVersion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "tasks",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a0e61fcaf07658f243d0b617b496a13",
    "id": null,
    "metadata": {},
    "name": "KPIEditUnitMutation",
    "operationKind": "mutation",
    "text": "mutation KPIEditUnitMutation(\n  $routineId: ID!\n  $updateTasks: [UpdateRoutineUpdateTaskInput!]!\n) {\n  routine(id: $routineId) {\n    update(input: {updateTasks: $updateTasks}) {\n      routine {\n        id\n        activeVersion {\n          tasks {\n            __typename\n            id\n            ... on TaskNumber {\n              unit\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5336798c4d45134a8f0569180019f201";

export default node;
